/**
 * @file seatch
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {SearchBar} from 'antd-mobile';
import ListPage from '../../components/ListPage';
import Loading from '../../components/Loading';

import {fetchCmsapiSearchArticle} from '../../actions/searchAction';


import './index.less';

export class Search extends Component {

    static propTypes = {
        fetchCmsapiSearchArticle: PropTypes.func,
        cmsapiSearchArticle: PropTypes.object,
        match: PropTypes.object,
        history: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
        const keywords = this.props.match.params.keywords;
        this.state = {
            keywords: keywords,
            value: keywords,
            showHistory: !keywords,
            notHavePage: false,
            loadingMore: true,
            searchHistory: this.searchHistory
        };
        this.MAX_HISTORY = 10;
    }

    componentWillMount() {
        if (this.isPC()) {
            const keywords = this.props.match.params.keywords;
            location.href = keywords ? `/search?kwd=${keywords}`
                : '/search';
        }
    }

    componentDidMount() {
        const value = this.state.value;
        value && this.loadSearchData(value);
    }

    onChange = value => {
        this.setState({value});
    };

    clear = () => {
        this.setState({value: ''});
        this.props.history.push('/search');
    };

    handleClick = () => {
        this.manualFocusInst.focus();
    };

    saveHistory(value) {
        let searchHistory = this.state.searchHistory;
        let valueIndex = searchHistory.indexOf(value);

        // 空字符串不添加历史
        if (value === '') {
            return;
        }

        // 去除重复的历史
        if (valueIndex !== -1) {
            searchHistory.splice(valueIndex, 1);
            searchHistory.unshift(value);
        } else {
            searchHistory.unshift(value);

        }

        // 最多10条历史
        const len = searchHistory.length;
        if (len > this.MAX_HISTORY) {
            searchHistory.splice(0, len - this.MAX_HISTORY);
        }

        localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
    }

    loadSearchData(value) {
        this.props.fetchCmsapiSearchArticle({
            kwd: value,
            catid: 0,
            page: 1
        }).then(() => {
            const articleList = this.props.cmsapiSearchArticle.itemlist.article_list;
            if (articleList.datalist.length) {
                this.setState({
                    curPage: articleList.cur_page,
                    notHavePage: false,
                    loadingMore: articleList.total_page > articleList.cur_page
                });
            } else {
                this.setState({
                    notHavePage: true
                });
            }
        });
    }

    onSubmit = value => {

        this.saveHistory(value);

        this.setState({
            showHistory: false,
            notHavePage: false,
            searchHistory: JSON.parse(localStorage.getItem('searchHistory'))
        }, () => {
            this.loadSearchData(value);
            this.setState({
                keywords: value
            });
        });

        this.props.history.push('/forum/search/' + value);
    };

    fetchPublish() {
        this.setState({
            loadingMore: false
        });
        const {keywords, curPage} = this.state;
        if (keywords !== undefined) {
            this.props.fetchCmsapiSearchArticle({
                kwd: keywords,
                catid: 0,
                page: curPage + 1
            }, true).then(() => {
                const articleList = this.props.cmsapiSearchArticle.itemlist.article_list;
                this.setState({
                    curPage: articleList.cur_page,
                    loadingMore: articleList.total_page > articleList.cur_page
                });
            });
        }
    }

    onCancel = () => {
        location.href = '/m/forum';
    };

    render() {
        this.shareWX({
            title: '搜索-百度安全社区',
            content: ' '
        });
        const {
            showHistory,
            searchHistory,
            notHavePage,
            loadingMore,
            value
        } = this.state;
        const cmsapiSearchArticle = this.props.cmsapiSearchArticle;
        let isMore = true;
        if (!this.isEmptyobj(cmsapiSearchArticle)) {
            const articleList = cmsapiSearchArticle.itemlist.article_list;
            isMore = articleList.total_page > articleList.cur_page;
        }

        return (
            <div className={'search'}>
                {this.isPC() ? ''
                    : <div>
                        <div className={'section search-box'}>
                            <SearchBar
                                value={value ? value : ''}
                                placeholder={'想找什么呢？'}
                                onSubmit={this.onSubmit}
                                onClear={this.clear}
                                onFocus={() => {
                                    if (this.state.showHistory) {
                                        return;
                                    }
                                    this.setState({
                                        showHistory: true
                                    });
                                }}
                                onCancel={this.onCancel}
                                showCancelButton
                                onChange={this.onChange}
                            />
                        </div>
                        {searchHistory.length !== 0 && <div className={'search-history-box section'} style={{
                            display: showHistory ? 'block' : 'none'
                        }}>
                            <div className={'search-title'}>搜索历史</div>
                            <div className={'search-history'}>
                                {searchHistory.map((item, index) => {
                                    return <div className={'just-bet'} key={'m' + index + item}>
                                        <div className={'search-key'} onClick={() => {
                                            this.setState({value: item});
                                            this.onSubmit(item);
                                        }}>{item}</div>
                                        <div
                                            className={'clear-note'}
                                            onClick={() => {
                                                const searchHistory = this.state.searchHistory;
                                                searchHistory.splice(index, 1);
                                                localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
                                                this.setState({
                                                    searchHistory: JSON.parse(localStorage.getItem('searchHistory'))
                                                });
                                            }}>
                                        </div>
                                    </div>;
                                })}
                            </div>
                        </div>}

                        <div className="page-main">
                            {!showHistory && <div className={'page-box'} style={{marginTop: '0.6rem'}}>

                                {
                                    !this.isEmptyobj(cmsapiSearchArticle)
                                        ? cmsapiSearchArticle.itemlist.article_list.datalist.map((item, index) => {
                                            return <a
                                                href={`/m/forum/page/${item.aid}`}
                                                key={index}
                                                className={'section'}
                                                target={'_black'}
                                            >
                                                <ListPage
                                                    title={item.title}
                                                    text={item.subtitle}/>
                                            </a>;
                                        }) : ''
                                }

                                {
                                    notHavePage ? <div className={'not-have-page pr'}>
                                        找不到你查询的内容啦~(&gt;_&lt;)~
                                    </div> : ''
                                }
                            </div>}
                            {!this.isEmptyobj(cmsapiSearchArticle)
                            && !showHistory
                            && cmsapiSearchArticle.itemlist.article_list.datalist.length
                            && !notHavePage
                                ? <Loading
                                    type={isMore}
                                    isLoad={loadingMore}
                                    callbackFn={this.fetchPublish.bind(this)}
                                    style={{paddingTop: '0.6rem', paddingBottom: '0.8rem'}}
                                    ref={el => this.loading = el}
                                /> : ''
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        cmsapiSearchArticle: state.cmsapiSearchArticle
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchCmsapiSearchArticle: (aidObj, isMore) => fetchCmsapiSearchArticle(dispatch, aidObj, isMore)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);




// WEBPACK FOOTER //
// ./src/containers/search/index.js